<!-- <ng-container *ngIf="showSpinner"> -->
  <mat-spinner diameter="50" strokeWidth="5.5"></mat-spinner>
<!-- </ng-container> -->